import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

const CustomModal = ({ 
  show,
  onHide, 
  headerIcon, 
  headerText, 
  body, 
  onSave ,
  secondaryBtnText,
  onSecondaryClick,
  size, 
  variant, 
  btnText, 
  isLoading, 
  btnCancelText, 
  dFlexBtn, 
  closeButton = true, 
  onUndoChanges, 
  hideSaveBtn, 
  footerStyle, 
  isAlsoDeleteModal, 
  scrollable,
  setIsConfirmDeleteStateArea,
  isConfirmDeleteStateArea,
  onDeleteAreaOrSottoarea,
  isLoadingAreaOrSottoareaDelete,
  hideButtons
}) => {

   
  return (
    <Modal show={show} onHide={onHide} centered size={size} scrollable={scrollable}>
      <Modal.Header closeButton={closeButton} className='bg-secondary'>
        <Modal.Title>
          {headerIcon && <headerIcon />}
          {headerText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-4'>{body}</Modal.Body>
      {
        !hideButtons && (
          <Modal.Footer className={`p-4 ${dFlexBtn ? 'd-flex justify-content-between' : ''} ${footerStyle}`}>
          {hideSaveBtn ? '' : (
            isLoading ? (
              <Button variant={variant} disabled>
                  <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
              />
                Caricamento...
              </Button>
            ) : (
              <>
            {!isConfirmDeleteStateArea && (
              <>
                <Button variant={variant} onClick={onSave}>
                  {btnText}
                </Button>

                {/* Secondo bottone opzionale */}
                {onSecondaryClick && secondaryBtnText && (
                  <Button 
                    variant={variant} 
                    onClick={onSecondaryClick} 
                    className="ms-2"
                  >
                    {secondaryBtnText}
                  </Button>
                )}
              </>
            )}
              </>
          ) 
          )}
          {!isAlsoDeleteModal ? 
            <Button variant="secondary" onClick={onUndoChanges}>
              {btnCancelText ?? 'Annulla'}
            </Button>
          : 
          <>
                { !isConfirmDeleteStateArea && ( 
                <Button variant="danger" onClick={() => setIsConfirmDeleteStateArea(true)}>
                  Elimina
                </Button>
                ) }
                { isConfirmDeleteStateArea && ( 
                  <>
                  {  isLoadingAreaOrSottoareaDelete ? 
                        <Button variant="success" disabled>
                        <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                      Caricamento...
                    </Button>
                  : 
                    <Button variant="success" onClick={onDeleteAreaOrSottoarea}>
                      Conferma eliminazione
                    </Button>
                    
                    }
                    <Button variant="secondary" onClick={() => setIsConfirmDeleteStateArea(false)}>
                      annulla
                    </Button>
                  </>
                ) }
          </>
          }
          </Modal.Footer>
        )
      }
    </Modal>
  );
};

export default CustomModal;
